export let LoadingKey;

(function (LoadingKey) {
  LoadingKey["InitiateVerificationRequest"] = "InitiateVerificationRequest";
  LoadingKey["CompleteVerificationRequest"] = "CompleteVerificationRequest";
  LoadingKey["SignupRequest"] = "SignupRequest";
  LoadingKey["StandardLoading"] = "StandardLoading";
  LoadingKey["BlankScreenLoading"] = "BlankScreenLoading";
  LoadingKey["LoginAfterSignup"] = "LoginAfterSignup";
  LoadingKey["PartnerExistingAccount"] = "PartnerExistingAccount";
  LoadingKey["PostSignupLoading"] = "PostSignupLoading";
})(LoadingKey || (LoadingKey = {}));